<div class="col-sm-12 col-md-6 col-lg-4 col-xl-2 rask-vit-panel p-4 mx-auto border">
  <div>
    <rask-button color="secondary" aid="azureLoginButton" (click)="loginRedirect()">Logga in</rask-button>
  </div>
</div>